export default __webpack_public_path__ + "static/media/FuelDrop.86467760.svg";